import { module } from 'angular';
import { FastImportService } from './fast-import.service';

export default module('app.routes.fastimport', [])

	.service('FastImportService', FastImportService)
	.name;
